export default __webpack_public_path__ + "static/media/groundtruth-text.b1dd7b2a.svg";